import { Component } from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { NandaChatComponent } from "../../shared/components/nanda-chat/nanda-chat.component";

@Component({
    selector: "app-dev",
    imports: [SharedDsnModule, SharedMaterialModule],
    templateUrl: "./dev.component.html",
    styleUrl: "./dev.component.scss"
})
export class DevComponent {}
